export const MAIN_DC_URL = 'https://manage.wix.com';
export const EVENTS_WEB_API_BASE = '/_api/wix-one-events-server';
export const MEMBERS_PERMISSIONS_BASE = '/_api/member-permissions-server';
export const SERVER_BASE_URL = 'https://events.wixapps.net/events-server';
export const IFRAME_BASE_URL = 'https://editor.wixapps.net/events-server';
export const PAYMENT_SERVICES_API_URL = '/_api/payment-services-web';
export const SCHEDULE_API_URL = '/_api/wix-events-schedule';
export const EVENTS_WEB_API_URL = '/_api/wix-events-web';
export const SEATINGS_API_URL = '/_api/seating-plans';
export const GROUPS_API_URL = '/_api/social-groups';
//# sourceMappingURL=endpoints.js.map